import { rgba } from 'polished';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { cFFFFFF } from '#/colors';
import { useLabelId } from '#/utils/useLabel';

interface Props {
  label: ReactNode;
  value: ReactNode;
}

export default function Description(props: Props) {
  const { label, value } = props;
  const labelId = useLabelId('description');

  return (
    <Container>
      <Label id={labelId}>{label}</Label>
      <Value aria-labelledby={labelId}>{value}</Value>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const Label = styled.div`
  font-size: 11px;
  color: ${rgba(cFFFFFF, 0.7)};
`;

const Value = styled.output`
  font-size: 11px;
`;
